import styled, { css } from 'styled-components';
import { rem } from 'polished';
import mediaqueries from '../../../config/themes/variables/mediaqueries';

const StyledButtons = styled.button`
  border: 0;
  font-family: ${props => props.theme.fonts.bold};
  font-weight: 700;
  font-size: ${rem('14px')};
  color: ${props => props.theme.colors.light};
  text-transform: uppercase;
  padding: ${rem('10px')} ${rem('20px')};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: 0.3s;

  &:hover,
  &:active {
    background-color: ${props => props.theme.colors.dark};
  }
  > svg {
    margin-right: ${rem('8px')};
  }

  ${props =>
    props.isFloat &&
    `  height: 40.5px;
  `};

  ${props =>
    props.primary &&
    `  background-color: ${props.theme.colors.secondary};
    `};
  ${props =>
    props.secondary &&
    ` background-color: ${props.theme.colors.primary};
    `};
  ${props =>
    props.dark &&
    ` background-color: ${props.theme.colors.grayDarker};
    `};
  ${props =>
    props.green &&
    css`
      background-color: green;
      color: white;
      &:hover,
      &:active {
        background-color: #006400;
      }
    `};
  ${props =>
    props.small &&
    ` padding: ${rem('8px')} ${rem('20px')};
        font-family: ${props => props.theme.fonts.medium};
        font-size: ${rem('14px')}
    `};

  ${props =>
    props.fixed &&
    css`
      bottom: 0;
      opacity: 0.95;
      padding: ${rem('22px')} ${rem('20px')};
      position: fixed;
      width: 100%;
      ${mediaqueries.greaterThan('mobile')`
        opacity: 1;
        padding: ${rem('12px')} ${rem('20px')};
        position: static;
        width: auto;
      `};
    `};

  ${props =>
    props.modal &&
    css`
      background-color: ${props.theme.colors.light};
      border: ${rem('2px')} solid ${props.theme.colors.grayDark};
      color: ${props.theme.colors.grayDark};
      &:hover {
        color: ${props => props.theme.colors.light};
      }
    `};

  ${props =>
    props.ghost &&
    css`
      background-color: transparent;
      border: ${rem('2px')} solid ${props.theme.colors.light};
      color: ${props.theme.colors.light};
      height: ${rem('30px')};
      font-size: ${props.theme.fontSize.xsmall};
      padding: ${rem('6px')} ${rem('20px')};

      &:hover,
      &:active {
        background-color: ${props.theme.colors.light};
        color: ${props.theme.colors.primary};
      }
    `};
  ${props =>
    props.ghost &&
    props.dark &&
    css`
      background-color: transparent;
      border: ${rem('2px')} solid ${props.theme.colors.dark};
      color: ${props.theme.colors.dark};
      font-size: 0.9375rem;
      padding: ${rem('6px')} ${rem('20px')};
      height: auto;

      &:hover,
      &:active {
        background-color: ${props.theme.colors.light};
        color: ${props.theme.colors.primary};
      }
    `};
  ${props =>
    props.transparent &&
    css`
      background-color: transparent;
      font: ${rem('13px')} ${props.theme.fonts.medium};
      color: ${props.theme.colors.dark};
      text-transform: none;
      & > svg {
        margin-left: ${rem('10px')};
        margin-right: ${rem('10px')};
      }

      &:hover,
      &:active {
        background-color: transparent;
        color: ${props.theme.colors.dark};
      }
    `};
  ${props =>
    props.disabled &&
    css`
      background-color: ${props.theme.colors.grayLightest};
      color: ${props.theme.colors.gray};
      cursor: default;

      &:hover,
      &:active {
        background-color: ${props.theme.colors.grayLightest};
        color: ${props.theme.colors.gray};
      }
    `};

  & > a {
    font-family: ${props => props.theme.fonts.bold};
  }
  ${mediaqueries.greaterThan('mobile')`
    font-size: ${props => props.theme.fontSize.medium};
    padding: ${rem('12px')} ${rem('20px')};
    ${props =>
      props.ghost &&
      css`
        padding: ${rem('4px')} ${rem('20px')};
      `}
      ${props =>
        props.small &&
        ` padding: ${rem('8px')} ${rem('20px')};
        font-family: ${props => props.theme.fonts.medium};
        font-size: ${rem('14px')}
    `};  
  `};
`;

export { StyledButtons };
